import React from "react"
import Title from "./Title"
import Project from "./Project"
import { Link } from "gatsby"
import projects from "../constants/projects";
const Projects = ({title}) => {
  return (
    <section className="section projects">
      <Title title={ title } />
      <div className="section-center projects-center">
        { projects.map((project, i) => {
          return <Project key={ project.id } index={ i } {...project}/>
        })}
      </div>
    </section>
  )
}

export default Projects
